import React, { useEffect } from 'react';
import { doc, updateDoc, increment } from 'firebase/firestore';
import { useOnScreen } from '../hooks/useOnScreen';
import './PaperItem.css'; // Ensure this path matches your project structure
import { useCookies } from 'react-cookie';


const PaperItem = ({ paper, db, handleVote }) => {
  const [ref, isVisible] = useOnScreen({ threshold: 0.5 });
  const [cookies, setCookie] = useCookies(['viewedPapers']);


  useEffect(() => {
    const viewed = cookies.viewedPapers || [];
  
    if (isVisible && !viewed.includes(paper.id)) {
      const paperRef = doc(db, 'papers', paper.id);
      updateDoc(paperRef, { views: increment(1) }).catch(console.error);
  
      const updated = [...viewed, paper.id];
      setCookie('viewedPapers', updated, { path: '/', maxAge: 60 * 60 * 24 * 365 }); // 1 year
    }
  }, [isVisible]);

  return (
    <li ref={ref}>
      <h3>
      {paper.citations >= 500
        ? '🔥🔥🔥🔥 '
        : paper.citations >= 200
        ? '🔥🔥🔥 '
        : paper.citations >= 100
        ? '🔥🔥 '
        : paper.citations >= 20
        ? '🔥 '
        : ''}{paper.title}
      </h3>
      <p><strong>Authors:</strong> {paper.authors.join(', ')}</p>
      <p><strong>Conference:</strong> {paper.conference}</p>
      <p><strong>First Date:</strong> {paper.firstDate}</p>
      <p><strong>Keywords:</strong> {paper.keywords.join(', ')}</p>
      <p className="abstract-text"><strong>Abstract:</strong> {paper.abstract}</p>
      <p><strong>PDF Link:</strong> <a href={paper.pdfLink} target="_blank" rel="noopener noreferrer">View PDF</a></p>
      <p><strong>Comment:</strong> {paper.comment}</p>
      <div className="paper-metrics">
      {typeof paper.citations === "number" && (
        <p><strong>Citations:</strong> {paper.citations}</p>
      )}
      {(paper.views || 0) >= (paper.votes || 0) && (
            <p><strong>Views:</strong> {paper.views || 0}</p>
        )}
      <p><strong>Votes:</strong> {paper.votes || 0}</p>
      </div>
      <button onClick={() => handleVote(paper.id)}>Vote</button>
    </li>
  );
};

export default PaperItem;
